module.exports = __webpack_public_path__ + "img/heading_goods.1338ed1c.png";